import { render, staticRenderFns } from "./BatchDetailPanal.vue?vue&type=template&id=463a6504&scoped=true&"
import script from "./BatchDetailPanal.vue?vue&type=script&lang=js&"
export * from "./BatchDetailPanal.vue?vue&type=script&lang=js&"
import style0 from "./BatchDetailPanal.vue?vue&type=style&index=0&id=463a6504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a6504",
  null
  
)

export default component.exports